// eslint-disable-next-line no-restricted-imports -- The only place needed to define useAppDispatch and useAppSelector
import { useDispatch, useSelector } from "react-redux";

// Infer the `RootState` and `AppDispatch` types from the store itself

// Use throughout app instead of plain `useDispatch` and `useSelector` to get type-safety
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;